import React from 'react';
import { MiniButton } from '@yme/atoms/mini-button';
import { ForwardBtnWithAnimation } from '@yme/molecules/buttons/ForwardBtnWithAnimation';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { ViewAllLinkStyled } from '../styled';
export function ViewAllMiniButton({ linkTo, isRightToLeft, viewAllLabel, tabIndex = 0, }) {
    return (React.createElement(ViewAllLinkStyled, { to: linkTo, isRightToLeft: isRightToLeft, tabIndex: tabIndex, lineColor: colorCoreBlack900Base },
        React.createElement(MiniButton, { isPaddingsReset: true, isRightToLeft: isRightToLeft }, viewAllLabel),
        React.createElement(ForwardBtnWithAnimation, { isRightToLeft: isRightToLeft })));
}
